import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 9.99976L10 13.7498M10 7.22021V7.18726M2.5 9.99976C2.5 5.85762 5.85787 2.49976 10 2.49976C14.1421 2.49976 17.5 5.85762 17.5 9.99976C17.5 14.1419 14.1421 17.4998 10 17.4998C5.85786 17.4998 2.5 14.1419 2.5 9.99976Z",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }